 <template>
  <div id="page-user-view">
    <page-title :title="title" />

    <card-full
      :data="info"
      :dataStructure="getDataStructureInChunk" 
      :showDeleteBtn="showDeleteBtn"
      :showEditBtn="showEditBtn"
      :showCancelBtn="showCancelBtn"
      :endPoint="endPoint"
      :editPage="editPage"

    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AronTable from "../../components/aron/table/tblmain";
import cardFull from "../../components/aron/dataViews/displayOptions/cardfull.vue";
import PageTitle from "../../components/aron/pageTitle";

import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";

export default {
  mixins: [axiosMixin, helperMixin],
  components: {
    cardFull,
    PageTitle,
    AronTable
  },
  data() {
    return {
      showActionButton: false,
      info: {},
      structure: {},
      showDeleteBtn: false,
      showCancelBtn: false,
      user_data: null,
      showEditBtn: true,
      title: "System Settings",
      endPoint: "settings",
      editPage: "edit_settings"
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo"
    }),

    getDataStructureInChunk() {
      var objCount = Math.ceil(Object.entries(this.structure).length / 2);
      var object = _.pickBy(this.structure, ["showInView", "yes"]);

      const arrayFromObject = Object.entries(object);
      return _.chunk(arrayFromObject, objCount);
    }
  },
  methods: {
    getData() {
      this.aronGet("settings", "", "")
        .then(response => {
          this.info = response.data.data[0];
          this.structure = response.data.fields;
 
          this.$store.dispatch("profile/setProfileId", this.vendorId);
          this.$store.dispatch("profile/setMainInfo", this.info);
          this.$store.dispatch("profile/setMainDataStructure", this.structure);
          this.$store.dispatch("profile/setEndPoint", "settings");
          this.$store.dispatch("profile/setCallBack", "profile");

          // this.closeLoading();
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          //this.closeLoading();
        });
    }
  },
  created() {
    this.reject_reason = "";
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
